import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { withTranslation } from 'react-i18next'

import { StyledRoot, StyledInput, StyledSearchIco } from './styled'

const WAIT_INTERVAL = 500	// wait 500ms before searching when user stopped typing
const ENTER_KEY = 13	// press Enter to immidiately execute search

class SearchInput extends Component {
	constructor(props) {
		super(props)
		const { value = '' } = props
		this.timer = null
		this.state = {
			value
		}
	}

	componentWillUnmount() {
		if(typeof this.props.onUnmount === 'function' && this.state.value !== this.props.value) {
			this.props.onUnmount(this.state.value)
		}
	}

	handleChange = (e) => {
		const value = e.target.value
		clearTimeout(this.timer)

		this.setState({ value })

		this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL)
	}

	handleKeyDown = (e) => {
		if (e.keyCode === ENTER_KEY) {
			this.triggerChange()
		}
	}

	triggerChange = () => {
		const { value } = this.state
		this.props.onSearch(value)
	}

	render({ inverted, style, t, isInTable, className } = this.props) {
		return (
			<StyledRoot isInTable={isInTable} isInverted={inverted} style={style} className={className}>
				<StyledInput
					value={this.state.value}
					onChange={this.handleChange}
					onKeyDown={this.handleKeyDown}
					placeholder={t('common.strings.search')}
					type='text'
				/><StyledSearchIco/>
			</StyledRoot>
		)
	}
}

SearchInput.propTypes = {
	onSearch: PropTypes.func.isRequired,
	value: PropTypes.string,
	onUnmount: PropTypes.func
}

export default withTranslation()(SearchInput)
